<template>
  <div
    v-if="isChatOpen"
    class="chat-window-shadow tw:w-full tw:md:w-[400px] tw:bg-white tw:md:rounded-xl tw:h-lvh tw:md:h-[700px] tw:flex tw:flex-col"
  >
    <div class="tw:flex tw:justify-between tw:px-6 tw:py-4 tw:border-b-1 tw:border-gray-300">
      <span class="tw:inline-flex">
        <span class="tw:mr-4">
          <TrivagoLogoSmall class="tw:w-[15px]" />
        </span>
        <span class="tw:font-bold tw:mr-1">{{ $t('chatbot_concierge') }}</span>
        <BetaIcon class="tw:self-center tw:w-[38px] tw:h-4" />
      </span>
      <button @click="onChatButtonClick" class="tw:cursor-pointer">
        <Close class="tw:size-3.5" />
      </button>
    </div>
    <ChatBody class="tw:p-6 tw:grow" />
    <ChatInput class="tw:p-6" />
  </div>
</template>

<script setup>
import Close from '@/components/icons/Close.svg?component'
import useChat from '@/components/chatbot/useChat'
import TrivagoLogoSmall from '@/components/icons/TrivagoLogoSmall.svg?component'
import BetaIcon from '@/components/icons/BetaIcon.svg?component'
import ChatInput from '@/components/chatbot/ChatInput.vue'
import ChatBody from '@/components/chatbot/ChatBody.vue'

import appAnalytics from '@/utils/tracking'

const { isChatOpen, conversationId, resetIdleTimer } = useChat()

const onChatButtonClick = () => {
  resetIdleTimer()
  appAnalytics.track(appAnalytics.events.CHAT_CLOSE_CLICKED, {
    conversation_id: conversationId.value,
  })
  isChatOpen.value = false
}
</script>

<style scoped>
.chat-window-shadow {
  box-shadow: 0px 4px 46px 0px rgba(0, 0, 0, 0.2);
}
</style>
